import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../../Components/Masters/MessagePopup";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI207_2 = ({ hide }) => {
   const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
 const questionData = [
    {
      fieldName: "taxGovernanceAccountability",
      title:
        "i. Which governance body or executive-level position within the organization is accountable for compliance with the tax strategy, and to what extent does the highest governance body oversee compliance?",
      type: "text",
      placeholder: "Enter Text",
      letter: "i.",
    },
    {
      fieldName: "taxStrategyEmbeddingInitiatives",
      title:
        "ii. How is the approach to tax embedded within the organization, and can you provide examples of initiatives or programs supporting adherence to the tax strategy, such as training, remuneration schemes, or participation in tax transparency initiatives?",
      type: "text",
      placeholder: "Enter Text",
      letter: "ii.",
    },
    {
      fieldName: "taxRiskManagementApproach",
      title:
        "iii. Describe the approach to tax risks, including examples of how risks are identified, managed, and monitored, considering factors such as compliance, uncertain tax positions, changes in legislation, and the organization's risk appetite and tolerance.",
      type: "text",
      placeholder: "Enter Text",
      letter: "iii.",
    },
    {
      fieldName: "taxGovernanceFrameworkEvaluation",
      title:
        "iv. How is compliance with the tax governance and control framework evaluated, and to what extent does the highest governance body have oversight of its design, implementation, and effectiveness?",
      type: "text",
      placeholder: "Enter Text",
      letter: "iv.",
    },
    {
      fieldName: "taxConcernsMechanisms",
      title:
        "b. Describe the mechanisms available for individuals to raise concerns about the organization's business conduct       and integrity in relation to tax, such as whistleblowing procedures.",
      type: "text",
      placeholder: "Enter Text",
      letter: "b.",
    },
    {
      fieldName: "taxDisclosureAssuranceProcess",
      title:
        "c. Provide a description of the assurance process for disclosures on tax, including any external assurance reports or statements. If applicable, please provide a link or reference to the external assurance report(s) or statement(s) covering the tax disclosures.",
      type: "text",
      placeholder: "Enter Text",
      letter: "c.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI200`);
      const res1 = res?.data?.data?.GRI200?.taxGovernace;
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data)
      setFormData({
        taxGovernanceAccountability: data?.taxGovernanceAccountability || "",
        taxStrategyEmbeddingInitiatives:
          data?.taxStrategyEmbeddingInitiatives || "",
        taxRiskManagementApproach: data?.taxRiskManagementApproach || "",
        taxGovernanceFrameworkEvaluation:
          data?.taxGovernanceFrameworkEvaluation || "",
        taxConcernsMechanisms: data?.taxConcernsMechanisms || "",
        taxDisclosureAssuranceProcess:
          data?.taxDisclosureAssuranceProcess || "",
      });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (!formData[el.fieldName] || formData[el.fieldName].trim() === "") {
        newErrors[el.fieldName] = "This field is Required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;

      let transformedData2 = {
        taxGovernace: formData,
        type: "GRI200",
        submitted207_2: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/economic-performance/207-3/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/economic-performance/207-3/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {/* <Box sx={{ display: "flex" }}> */}
      {!hide && <p className={styles.section_heading}>207 : Tax 2019</p>}
      <p className={styles.main_heading} >
        207-2 : Tax governance, control, and risk management
      </p>
      {/* a */}
      <p
        className={styles.ques_heading}
        style={{ marginTop: hide ? "-1rem" : "2rem", marginBottom: "-1rem" }}
      >
        a. Tax Governance and Control Framework
      </p>
      {questionData.map((el) => (
        <Box sx={{ mt: hide ? "-1rem" : "1rem" }}>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            {/* <p className={styles.ques_heading}>{el.letter}</p> */}
            <p className={styles.ques_heading} style={{textIndent:el?.letter==="iii." || el?.letter==="b." || el?.letter==="iv." ? "-1.3rem":el?.letter==="i." && "-0.8rem"

            }}>{el.title}</p>
          </Box>
          <Box
            sx={{ ml: 2 }}
          >
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              errors={errors[el.fieldName] && true}
              disabled={disabled}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[el.fieldName]}
            </p>
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI207_2;
